import _ from 'lodash';
import moment from 'moment';
import { BaseModel } from '../lib';
import _renameKeys from '../../lib/snowjs/lodash-mixins/rename-keys';


export default class NewsModel extends BaseModel {

  // publishedBooleanValue is a virtual transient property
  get publishedBooleanValue() {
    return !this.archivedBooleanValue;
  }
  set publishedBooleanValue(value) {
    this.archivedBooleanValue = !value;
  }

  get archivedBooleanValue() {
    return !!this.archived;
  }
  set archivedBooleanValue(value) {
    if (value) {
      if (!this.archived) {
        this.archived = this._convertToDateString(moment());
      }
    } else {
      this.archived = null;
    }
  }

  get archivedMomentValue() {
    return this._convertToMomentValue(this.archived);
  }
  set archivedMomentValue(value) {
    this.archived = this._convertToDateString(value);
  }

  get sortIndexIntValue() {
    return this._convertToInteger(this.sort_index);
  }
  set sortIndexIntValue(value) {
    this.sort_index = this._convertIntegerToIntegerString(value);
  }

  toPublishedData() {
    let intKeys = 'id'.split(' ');
    let obj = _.toPlainObject(this);
    _.each(intKeys, k => {
      _.set(obj, k, _.parseInt(_.get(obj, k)));
    });
    delete obj.manager_notes;
    _renameKeys(obj, { sort_index: 'sortIndex' });

    return obj;
  }
}
